module.exports = __webpack_public_path__ + "static/media/map-pin-filled.04d35c32.svg";